/** The palette's list of screens, derived from the route table - v5, stage F1.
 *
 * **There is no longer a list of destinations in this file.** Until 2026-11-01 it held the rail's
 * twenty-one entries and a second list of the screens the person's menu reached, and the shell
 * search's own header recorded the defect that justified one list: *out of the rail means out of
 * the search too*. The eleven places and every screen under them are in `routeTable.ts` now, and
 * this file only shapes them for the palette (`paletteModel.ts`): a screen's name, the icon of the
 * place it sits in, and that place's name as its group, so a query for "targets" finds the screens
 * under Targets & plan.
 *
 * The palette is handed the screens **the signed-in role is offered** - the same filter the rail
 * applies - so it cannot name a screen the rail does not.
 */

import type { Icon } from "@phosphor-icons/react";

import { placesFor, sectionById } from "./routeTable";

export interface NavItem {
  to: string;
  icon: Icon;
  label: string;
  group: string;
  badge?: "tasks";
  /** What the tab strip calls this screen when that differs from its name ("Factors" for the
   * Factor library): a person types the word they can see on the page. */
  alias?: string;
}

/** The palette's screens for a role, in the rail's order and the tabs' order within a place. */
export function paletteScreens(role: string | undefined): readonly NavItem[] {
  return placesFor(role).map((place) => {
    const section = sectionById(place.nav);
    return {
      to: place.to,
      icon: section.icon,
      label: place.label,
      group: section.label,
      ...(place.tab !== undefined && place.tab.toLowerCase() !== place.label.toLowerCase()
        ? { alias: place.tab }
        : {}),
    };
  });
}
